import axios from "dev/packages/MyAxios";

export const types = {
    GET: "outside/get",
    SAVE: "outside/save",
    PAYMENT: "outside/payment",
};
const OutsideModule = {
    state: {
        client: {},
    },
    mutations:{
        [types.GET](state,client){
            state.client = client;
        }
    },
    getters: {},
    actions: {
        async [types.GET]({commit},clientId){
            const client =  (await axios.get(`outside/${clientId}`)).data;
            commit(types.GET,client);
            return client;
        },
        async [types.SAVE]({commit}, {clientId,form}){
            return (await axios.post(`outside/${clientId}`, form)).data;
        },
        async [types.PAYMENT]({commit}, {uuid,form}){
            return (await axios.post(`outside/confirm/${uuid}`, form)).data;
        }
    }
};
export default OutsideModule;
